import {
	getColorForVariant,
	getHexOneForVariant,
} from "../../utils/commercetools/product-list";
import { getSlugForProductVariant } from "../../utils/storyblok/product-variant";
import { isProductStringAttribute } from "../../utils/type-guards/product-attribute";

export type Variant = {
	id: string;
	fabric: string | null;
	url: string;
	name: string;
	hexOne: string;
	hexTwo?: string | null;
	frame?: string | null;
	sort_order: number;
	toy?: string | null;
	color: string;
	variantSymbolImage: { src: string; alt?: string };
};

export const getVariantStringAttribute = (
	variant?: Queries.ProductVariantFragment | null,
	name?: string | null,
): string | undefined | null => {
	if (!variant || !name) return undefined;
	const attribute = variant.attributes.find(
		(attribute) => attribute.name === name,
	);

	return isProductStringAttribute(attribute)
		? attribute.stringValue
		: undefined;
};

export const getVariants = (
	product: Queries.CommerceToolsProductFragment,
): Variant[] => {
	return [product.masterVariant, ...product.variants]
		.reduce((variants, variant) => {
			const fabric = getVariantStringAttribute(variant, "fabric");
			const name = getVariantStringAttribute(variant, "color");
			const hexOne = getHexOneForVariant(variant);
			const hexTwo = getVariantStringAttribute(variant, "hex-color-patch-2");
			const slug = getSlugForProductVariant(variant);
			const sort_order = Number.parseInt(
				variant?.storyblok_variant_pages?.[0]?.sort_order ?? "0",
			);
			const id = variant?.id ?? "";
			const toy = getVariantStringAttribute(variant, "toy");
			const color = getColorForVariant(variant);
			const variantSymbolImage = {
				src: variant?.variantSymbolImage?.src ?? "",
				alt: variant?.variantSymbolImage?.alt ?? undefined,
			};

			if (!variant || !name || !slug) return variants;
			return [
				...variants,
				{
					id,
					fabric: fabric ?? null,
					url: `/${slug}`,
					hexOne,
					hexTwo,
					name,
					sort_order,
					toy,
					color,
					variantSymbolImage,
				},
			];
		}, [] as Variant[])
		.sort();
};
